import { Component, OnInit } from '@angular/core';
import { LoadingService } from '@core/services/loading.service';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss']
})
export class LoadingScreenComponent implements OnInit {

 public isLoading :boolean = false;
  
  /*----------  Constructor  ----------*/
  constructor(private loadingService: LoadingService) {

  }    
  /*----------  Loading Screen  ----------*/
  ngOnInit(): void {
    this.loadingService.isLoading$.subscribe(isLoading => this.isLoading = isLoading);
    
  }

}
